import React, { useCallback } from 'react';
import CommunicationPipelineStatusStep from './CommunicationPipelineStatusStep';
import { statusSteps, statusProgress, statusSign } from './constants/options';

export default function CommunicationPipelineStatusTimeLine(props) {
  const {
    report,
    isAdmin = false,
  } = props;

  const getProgress = useCallback(
    (progress) => {
      let color;
      let msg;
      let value;

      switch (progress) {
        case 'denied':
          color = statusSign[0]?.color;
          msg = statusSign[0]?.label;
          value = statusSign[0]?.value;
          break;
        case 'redirected':
          color = statusSign[1]?.color;
          msg = statusSign[1]?.label;
          value = statusSign[1]?.value;
          break;
        case 'informationRequest':
          color = statusSign[2]?.color;
          msg = statusSign[2]?.label;
          value = statusSign[2]?.value;
          break;
        case 'approved':
          color = statusSign[3]?.color;
          msg = statusSign[3]?.label;
          value = statusSign[3]?.value;
          break;
        case 'inProgress':
          color = statusProgress[1]?.color;
          msg = statusProgress[1]?.label;
          value = statusProgress[1]?.value;
          break;
        case 'completed':
          color = statusProgress[2]?.color;
          msg = statusProgress[2]?.label;
          value = statusProgress[2]?.value;
          break;
        default:
          // unInitialized
          color = statusProgress[0]?.color;
          msg = statusProgress[0]?.label;
          value = statusProgress[0]?.value;
      }

      return { color, msg, value };
    },
    [statusProgress, statusSign]
  );

  const getStatusInfo = useCallback(
    (step) => {
      let statusInfo;

      if (report?.status?.step === step) {
        statusInfo = getProgress(report?.status?.progress);
      } else if (
        step === 'sign' &&
        statusSteps.findIndex((statusStep) => statusStep.value === step) <
        statusSteps.findIndex(
          (statusStep) => statusStep.value === report?.status?.step
        )
      ) {
        statusInfo = getProgress('approved');
      } else if (
        statusSteps.findIndex((statusStep) => statusStep.value === step) <
        statusSteps.findIndex(
          (statusStep) => statusStep.value === report?.status?.step
        )
      ) {
        statusInfo = getProgress('completed');
      } else if (report?.status?.step === step) {
        statusInfo = getProgress(report?.status?.progress);
      } else {
        statusInfo = getProgress();
      }

      return statusInfo;
    },
    [report]
  );

  return (
    <div className="d-flex justify-content-center flex-wrap">
      {statusSteps.map((ss) => (
        <React.Fragment key={ss?.value}>
          <CommunicationPipelineStatusStep
            currentStatus={report?.status}
            statusInfo={getStatusInfo(ss?.value)}
            statusStep={ss}
            statusDate={report?.status?.date?.[ss?.value]}
            isAdmin={isAdmin}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
